import * as React from 'react';

import {DocumentHeader} from './DocumentHeader';

interface OwnProps {
  documentTitle: string;
  documentSubTitle?: string;
  documentTimeStamp?: string;
}

type Props = OwnProps;

export const DocumentHeaderContainer: React.FC<Props> = (props) => {
  const {documentTitle, documentSubTitle, documentTimeStamp} = props;
  return (
    <DocumentHeader
      title={documentTitle}
      subTitle={documentSubTitle}
      documentTimeStamp={documentTimeStamp}
    />
  );
};

DocumentHeaderContainer.displayName = 'DocumentHeaderContainer';
